import { Inject, Injectable } from '@angular/core';
import { Brand } from './brand.enum';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class BrandService {
  private _brand = new BehaviorSubject<Brand>(Brand.SKRILL_AND_NETELLER);

  get brand(): Observable<Brand> {
    return this._brand.asObservable();
  }

  constructor(
    private activateRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: any
  ) {
    this.initBrand();
  }

  initBrand() {
    this.activateRoute.queryParams.subscribe((params) => {
      const brand = String(params['brand']).toUpperCase();
      const rid = String(params['rid']).toUpperCase();

      if (Brand[rid]) {
        this._brand.next(Brand[rid]);
      } else if (Brand[brand]) {
        this._brand.next(Brand[brand]);
      } else {
        const domainElements = this.document.location.hostname.split('.');
        domainElements.forEach((el) => {
          if (el === Brand[el.toUpperCase()]) {
            this._brand.next(Brand[el.toUpperCase()]);
          }
        });
      }
    });
  }
}
